export enum SecuritiesModalDataSectionEnum {
  CHART = 1,
  STATISTIC_TABLE,
}
